/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Operation {
  ASSIGNED = "ASSIGNED",
  COMPLETE = "COMPLETE",
  DELETED = "DELETED",
  IN_COMPLETE = "IN_COMPLETE",
  REWORDED = "REWORDED",
  UNASSIGNED = "UNASSIGNED",
}

export interface IndividualInlineTaskNotificationInput {
  operation: Operation;
  recipientAccountId: string;
  taskId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateInlineTaskNotification
// ====================================================

export interface CreateInlineTaskNotification_createInlineTaskNotification_errors {
  message: string | null;
}

export interface CreateInlineTaskNotification_createInlineTaskNotification {
  contentId: string;
  success: boolean;
  errors: CreateInlineTaskNotification_createInlineTaskNotification_errors[] | null;
}

export interface CreateInlineTaskNotification {
  createInlineTaskNotification: CreateInlineTaskNotification_createInlineTaskNotification;
}

export interface CreateInlineTaskNotificationVariables {
  contentId: string;
  tasks: (IndividualInlineTaskNotificationInput | null)[];
}
